import { createFileRoute } from '@tanstack/react-router'

import { ContractPage } from '../../../../../components/pages/contract/contract-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/contracts/$subscriptionId/')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <ContractPage />
    </PermissionChecker>
  ),
})
